var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHips2Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 112,
    viewBox: "0 0 86 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1627_9740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8552 34.6932C15.8552 34.6932 25.4557 39.1397 44.8038 39.3434C61.9003 39.5244 71.7384 35.2589 71.7384 35.2589C71.7384 35.2589 74.3408 48.2082 73.9221 48.9606C73.5035 49.713 74.2502 66.0567 74.2502 66.0567L73.6166 78.5988C73.6166 78.5988 70.0751 80.8956 59.8919 80.641C49.7087 80.3864 45.4431 76.8676 45.4431 76.8676L44.4926 70.3845L42.043 69.9545L41.3189 76.3642C41.3189 76.3642 38.1507 80.3864 24.6976 79.3794C11.2444 78.3725 11.8215 76.3642 11.8215 76.3642L13.0944 50.3071L15.8665 34.6875L15.8552 34.6932Z",
    fill: "#909091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2861 -29.9204C13.5181 -28.1723 12.5564 -23.6296 12.9976 -20.6822C13.6369 -16.3544 14.2026 -12.5641 14.8815 -8.98874C16.7541 0.809543 16.8276 0.702055 17.7724 7.73396C18.5475 13.4987 18.3664 16.3838 17.5857 19.6763C16.7994 22.9632 16.0639 26.035 15.7924 31.4942C15.7245 32.8237 15.7584 33.9212 15.7924 34.6396C12.9976 46.3953 11.4136 61.9187 11.8662 80.1462C12.1773 92.7279 13.7953 102.379 15.7641 111.544",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0081 111.815C37.9981 104.082 38.9655 96.2864 39.899 88.4342C40.6344 82.2396 41.3472 76.0789 42.0374 69.9521C42.3712 70.1048 42.7955 70.2519 43.2934 70.3311C44.7303 70.5574 45.9014 70.0879 46.4388 69.8276",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4681 110.941C50.942 103.887 49.9916 98.2465 49.2052 94.3487C48.3962 90.3264 47.706 87.9164 46.4388 81.7783C45.4487 76.9754 44.7416 73.0153 44.3003 70.3904",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.331 110.066C73.2093 98.9269 73.7467 89.6038 73.8429 82.7869C73.9561 75.0535 74.5331 77.7916 73.9674 58.9022C73.8486 54.8629 74.8386 49.2397 73.4639 41.8061C72.9377 38.9605 72.372 36.6241 71.9534 35.0174C72.0382 33.0996 72.0665 30.1579 71.7044 26.5939C71.0652 20.3936 69.6169 18.357 68.9097 13.6445C68.095 8.21358 69.7074 7.57997 71.2066 -1.44328C72.768 -10.8682 72.8755 -12.1637 72.4625 -17.787C72.372 -18.9806 72.8981 -21.6904 72.6832 -25.328C72.5134 -28.2188 72.9604 -32.1789 72.5417 -34.0627",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7311 -70.4634C53.1993 -66.509 53.3973 -63.29 53.7142 -61.3496C53.8669 -60.4049 54.2742 -59.511 54.9135 -58.7982C56.1694 -57.4009 57.8384 -56.5127 59.7675 -55.9187C59.8467 -55.8961 59.9203 -55.8678 59.9938 -55.8338L68.1008 -52.2698C68.1573 -52.2472 68.2196 -52.2189 68.2761 -52.2019C73.9957 -50.2671 75.7948 -50.3973 78.2727 -49.0904C83.5906 -46.2845 86.2552 -36.2033 86.2552 -29.4769C86.2552 -28.1248 86.1647 -28.1531 84.4109 -17.659C83.4605 -11.9565 82.5157 -6.28234 82.148 -3.70265C80.6827 6.60478 81.8538 14.1402 82.3346 20.2443C83.0135 28.7924 82.8891 41.4136 78.9402 58.3343C79.3645 62.9449 78.5895 66.6674 78.7535 69.2697C78.9402 72.285 77.6673 74.3781 77.4354 74.9269C75.9928 78.3439 75.9305 78.5419 74.42 79.7355",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5442 -70.4634C33.0759 -66.509 32.8779 -63.29 32.5611 -61.3496C32.4084 -60.4049 32.001 -59.511 31.3618 -58.7982C30.1058 -57.4009 28.4369 -56.5127 26.5078 -55.9187C26.4286 -55.8961 26.355 -55.8678 26.2815 -55.8338L18.1745 -52.2698C18.1179 -52.2472 18.0557 -52.2189 17.9991 -52.2019C12.5398 -50.3577 9.37734 -49.5713 8.00261 -49.0904C2.42447 -47.1387 0.829098 -36.967 0.438742 -34.4835C0.155875 -32.6789 -0.0308184 -30.3764 1.86439 -17.659C3.15992 -8.96386 3.62948 -7.49298 4.12733 -3.70265C5.47377 6.49164 4.46111 13.8404 4.04247 18.9884C3.34661 27.5817 3.44845 40.4179 7.32938 58.3343C6.90508 62.9449 7.68014 66.6674 7.51608 69.2697C7.32938 72.285 8.60228 74.3781 8.83424 74.9269C10.2769 78.3439 10.3391 78.5419 11.8496 79.7355",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5139 16.9173C44.3512 16.0744 45.709 16.0744 46.5576 16.9117",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27648 68C1.67439 84.8155 2.00149 93.9311 6.45031 109.676",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6156 109.665C85.1811 93.8622 85.7721 84.721 82.9969 68.0412",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1627_9740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 112,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHips2Male);
export default __webpack_public_path__ + "static/media/hips-2-male.7bbc49a2ffb57a8dfa7b08033130a61e.svg";
export { ForwardRef as ReactComponent };